import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Link } from "react-router-dom";
import { Avatar, DropdownMenu, Icon, Typography } from "@/components/atoms";
import { getPhpHostUrl } from "@/helpers/apiHelpers";
import { useProfile } from "@/hooks";
import { useAppResetApi } from "@/redux/hooks";
import { clsx, getAssetUrl } from "@/utils";

export const HeaderProfileMenu = () => {
  const resetApi = useAppResetApi();
  const { logout } = useKindeAuth();
  const phpHostUrl = getPhpHostUrl();

  const handleLogout = async () => {
    resetApi();

    // In production, redirect to PHP logout which handles both PHP session and Kinde logout
    if (import.meta.env.MODE === "production") {
      window.location.href = `${phpHostUrl}/logout`;
    } else {
      // In development, just do Kinde logout
      await logout();
    }
  };

  return (
    <DropdownMenu button={<HeaderProfile className="cursor-pointer hover:rounded hover:bg-neutral-mid-gray" />} position="bottom-start">
      <Link to="profile">
        <DropdownMenu.Item className="flex w-48 flex-row items-center gap-x-2.5">
          <Icon name="Profile" size="sm" />
          <Typography>Your Profile</Typography>
        </DropdownMenu.Item>
      </Link>
      <DropdownMenu.Item className="flex w-48 flex-row items-center gap-x-2.5" onClick={handleLogout}>
        <Icon name="LogoutCurve" size="sm" className="rotate-180" />
        <Typography>Logout</Typography>
      </DropdownMenu.Item>
    </DropdownMenu>
  );
};

export const HeaderProfile = ({ className }: { className?: string }) => {
  const profile = useProfile();

  const { avatar, displayName } = profile;
  const avatarUrl = getAssetUrl(avatar, { height: 120, width: 120, fit: "cover" });

  return (
    <div className={clsx("flex flex-shrink-0 items-center gap-x-3 p-1", className)} data-testid="header-profile">
      <Avatar src={avatarUrl} alt={displayName} size="sm" />
      <Typography variant="action" className="hidden sm:block">
        {displayName}
      </Typography>
    </div>
  );
};
